import {
  RemoveCircleOutline as RemoveCircleOutlineIcon,
  WarningAmber as WarningAmberIcon,
} from '@mui/icons-material'
import { MenuItem, TextField } from '@mui/material'
import { DismissReasonId, MicroLearningDetailResponse } from '../../../api/models'
import styles from '../MicroLearningDetail.module.css'
import { MicroLearningActionModal } from './MicroLearningActionModal'

export const DISMISS_REASON_OPTIONS: Array<{ id: DismissReasonId; label: string }> = [
  { id: 'insufficient_evidence', label: 'Insufficient evidence' },
  { id: 'duplicate', label: 'Duplicate of existing learning' },
  { id: 'not_relevant', label: 'Not relevant to business needs' },
  { id: 'low_quality', label: 'Low quality / inaccurate' },
  { id: 'outdated', label: 'Outdated information' },
  { id: 'other', label: 'Other' },
]

type DismissModalProps = {
  open: boolean
  data: MicroLearningDetailResponse | null
  selectedReason: DismissReasonId | ''
  additionalContext: string
  onSelectedReasonChange: (value: DismissReasonId | '') => void
  onAdditionalContextChange: (value: string) => void
  onClose: () => void
  onContinue: () => void
}

export default function DismissModal({
  open,
  data,
  selectedReason,
  additionalContext,
  onSelectedReasonChange,
  onAdditionalContextChange,
  onClose,
  onContinue,
}: DismissModalProps) {
  return (
    <MicroLearningActionModal
      open={open}
      onClose={onClose}
      onConfirm={onContinue}
      confirmText='Dismiss Permanently'
      confirmDisabled={!selectedReason}
      theme='danger'
      headerIcon={<RemoveCircleOutlineIcon style={{ color: '#b71c1c', fontSize: 20 }} />}
      title='Dismiss Micro-Learning'
      subtitle='This action will archive the micro-learning permanently'
      mlId={data?.ml_id || '—'}
      mlTitle={data?.generation?.title || data?.title || 'Micro-Learning'}
      score={data?.score}
      warningBanner={
        <div className={styles.dismissWarningBanner}>
          <WarningAmberIcon fontSize='small' className={styles.warningBannerIcon} />
          <span>
            Dismissing this micro-learning will permanently remove it from the review queue. This action cannot be undone.
          </span>
        </div>
      }>
      <TextField
        select
        fullWidth
        size='small'
        value={selectedReason}
        onChange={event => onSelectedReasonChange(event.target.value as DismissReasonId | '')}
        label='Reason for dismissal'>
        <MenuItem value='' disabled>
          Reason for dismissal
        </MenuItem>
        {DISMISS_REASON_OPTIONS.map(option => (
          <MenuItem key={option.id} value={option.id}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        multiline
        minRows={4}
        fullWidth
        size='small'
        value={additionalContext}
        placeholder='Provide additional context for the dismissal if you want...'
        onChange={event => onAdditionalContextChange(event.target.value.slice(0, 500))}
      />
      <span className={styles.dismissContextCounter}>{additionalContext.length}/500 characters</span>
    </MicroLearningActionModal>
  )
}
